import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './banner-mid-page-full-width.component.scss';
import Slider from '../slider/slider.component';
var BannerMidPageFullWidth = /** @class */ (function (_super) {
    tslib_1.__extends(BannerMidPageFullWidth, _super);
    function BannerMidPageFullWidth(element) {
        return _super.call(this, element) || this;
    }
    BannerMidPageFullWidth.prototype.init = function () {
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.sliderPagination = this.element.querySelector('.swiper-pagination');
        this.sliderNext = this.element.querySelector('.swiper-button-next');
        this.sliderPrev = this.element.querySelector('.swiper-button-prev');
        this.sliderConfig = {
            slidesPerView: 1,
            spaceBetween: 0,
            initialSlide: 0,
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev
            },
            autoplay: {
                delay: 7000
            }
        };
        Slider.init(this.sliderContainer, this.sliderConfig);
    };
    BannerMidPageFullWidth.prototype.bindEvents = function () { };
    return BannerMidPageFullWidth;
}(Base));
export { BannerMidPageFullWidth };



//////////////////
// WEBPACK FOOTER
// ./components/banner-mid-page-full-width/banner-mid-page-full-width.component.ts
// module id = 136
// module chunks = 0